<template>
  <div class="user-account">
    <v-card class="card mt-5 pa-3" width="100%" max-width="600">
      <div class="account-header mb-3">
        <div class="image-container">
          <img
            class="user-image"
            :src="getProfilePictureURL"
            :alt="displayName"
          />
          <!-- <p class="change-user-image-text caption">Change Image</p> -->
        </div>

        <div class="profile-name-and-email ml-4">
          <p class="title mb-1 mt-3">{{ displayName }}</p>
          <p class="subheading">{{ emailAddress }}</p>
        </div>
      </div>
      <v-divider></v-divider>

      <div>
        <div class="settings">
          <div class="setting-title mt-3">
            <div class="setting-text">
              <p class="subheading mb-0">{{ displayName }}</p>
              <p class="body-1">Change your display name.</p>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              @click="
                showSetChangeNameDialog = true;
                newDisplayName = '';
                newDisplayName = displayName;
                changeNameFeedback = null;
              "
              flat
              >Change</v-btn
            >
          </div>
          <v-divider></v-divider>
        </div>

        <div v-if="providerIsEmail">
          <div class="setting-title mt-3">
            <div class="setting-text">
              <p class="subheading mb-0">Reset Password</p>
              <p class="body-1">
                Link with password reset will be sent to {{ emailAddress }}
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="showResetPasswordDialog = true" flat>Reset</v-btn>
          </div>
          <v-divider></v-divider>
        </div>

        <div class="setting-title mt-3">
          <div class="setting-text">
            <p class="subheading mb-0">Delete Account</p>
            <p class="body-1">Delete your EarBeater Account.</p>
          </div>
          <v-spacer></v-spacer>
          <v-btn flat color="red" @click="confirmDeletion">Delete</v-btn>
        </div>
      </div>
      <!-- End Settings -->
    </v-card>

    <!-- Confirm delete account dialog -->

    <v-dialog v-model="showConfirmDeleteDialog" max-width="300px">
      <v-card>
        <v-card-title class="headline pb-0">Delete Account??</v-card-title>
        <v-card-text
          >Are you sure you want to delete your account? It cannot be
          undone.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            flat
            @click="showConfirmDeleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="red darken-1" flat @click="deleteUserAccount"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="showResetPasswordDialog" max-width="300px">
      <v-card>
        <v-card-title class="headline pb-0">Reset Your Password?</v-card-title>
        <v-card-text>Click Reset Password and we will send a link to {{ emailAddress }}. Click on the link to reset your password.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            flat
            @click="showResetPasswordDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="red darken-1" flat @click="resetPassword"
            >Reset Password</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Change display name dialog -->

    <v-dialog
      v-model="showSetChangeNameDialog"
      max-width="400px"
      persistent
      :fullscreen="breakpoint.xsOnly"
      :hide-overlay="breakpoint.xsOnly"
    >
      <v-card rounded center>
        <v-toolbar dense flat color="grey darken-3" dark>
          <v-toolbar-title>Change Display Name</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showSetChangeNameDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class=pb-0>
          <v-text-field
            v-model="newDisplayName"
            label="Your name"
            color="teal"
            class="mt-3"
            autofocus
            :rules="userDisplayNameRules"
            @keyup.enter="updateDisplayName"
          ></v-text-field>
          <p class="red--text">{{ changeNameFeedback }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="showSetChangeNameDialog = false"
            >Cancel</v-btn
          >
          <v-btn flat color="teal" dark large @click="updateDisplayName">
            Change name
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
  </div>
</template>

<script>
import firebase from "firebase/app";
export default {
  name: "userAccount",
  data() {
    return {
      newDisplayName: "",
      displayName: "",
      showConfirmDeleteDialog: false,
      showSetChangeNameDialog: false,
      showResetPasswordDialog: false,
      userDisplayNameRules: [(v) => v.length > 0 || "You must enter your name"],
      changeNameFeedback: null,
    };
  },
  methods: {
    resetPassword() {
      const auth = firebase.auth();
      auth
        .sendPasswordResetEmail(this.emailAddress)
        .then(() => {
          this.showResetPasswordDialog = false;
          // Email sent.
          this.$store.dispatch("setSnackbar", {
            timeout: 3000,
            text: `A password reset email was sent to ${this.emailAddress}`,
          });
        })
        .catch(function (error) {
          this.$store.dispatch("setSnackbar", {
            timeout: 5000,
            text: `An error happened sending a password reset email to ${this.emailAddress}. Please try again later.`,
          });
        });
    },
    updateDisplayName() {
      if (this.displayName === this.newDisplayName) {
        this.changeNameFeedback = "That's your name already...";
        return;
      }
      let user = firebase.auth().currentUser;
      user
        .updateProfile({
          displayName: this.newDisplayName,
        })
        .then(() => {
          user.reload().then(() => {
            // Set user object
            this.$store.dispatch("setUserObject", user);
            this.displayName = user.displayName;
            this.$store.dispatch("setSnackbar", {
              timeout: 3000,
              text: `Your display name was changed to ${user.displayName}.`,
            });
          });
          this.showSetChangeNameDialog = false;
        })
        .catch(() => {
          this.$store.dispatch("setSnackbar", {
            timeout: 3000,
            text: `An error happened. Please try again later.`,
          });
          this.showSetChangeNameDialog = false;
        });
    },
    confirmDeletion() {
      this.showConfirmDeleteDialog = true;
    },
    deleteUserAccount() {
      const user = firebase.auth().currentUser;
      user
        .delete()
        .then(() => {
          this.showConfirmDeleteDialog = false;
          this.$router.push("/");
          this.$store.dispatch("setSnackbar", {
            timeout: 3000,
            text: `Your account was deleted. Bye Bye!`,
          });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            timeout: 3000,
            text: `Could not delete your user account. Please sign out and back in and try again.`,
          });
        });
    },
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    emailAddress() {
      return firebase.auth().currentUser.email;
      // return this.$store.getters.getUserObject.email;
    },
    providerIsEmail() {
      const provider = firebase.auth().currentUser.providerData[0].providerId;
      if (provider === "password") {
        return true;
      } else {
        return null;
      }
    },
    getProfilePictureURL() {
      if (firebase.auth().currentUser.photoURL) {
        return firebase.auth().currentUser.photoURL + '?access_token=' + this.$store.state.accessToken;
        // return firebase.auth().currentUser.photoURL;
      } else {
        return "images/standard-profile-picture50x50.png";
      }
    },
  },
  created() {
    this.displayName = firebase.auth().currentUser.displayName;
  },
};
</script>

<style>
.user-account {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.account-header {
  display: flex;
}
.user-account .profile-name-and-email {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  /* justify-content: center; */
}

.user-account .user-image {
  border-radius: 50%;
  height: 100px;
  width: 100px;
}
.user-account .change-user-image-text {
  text-align: center;
}
.user-account .setting-text {
  display: flex;
  flex-direction: column;
}
.user-account .setting-title {
  display: flex;
}
</style>